<template>
  <el-dialog v-if="DialogVisible" :visible.sync="DialogVisible" width="850px" class="large-padding-dialog"
    :close-on-click-modal="false" :before-close="Hide">
    <span slot="title" class="el-dialog__title">
      {{ mode == "quotation" ? "商机通" : "速采通" }}-开通
    </span>
    <!--当用户通过点击关闭图标或遮罩关闭 Dialog 时触发 before-close 对应方法-->

    <div
      style="display: flex;flex-direction: column; align-items: center;justify-content: center;gap:20px; padding-bottom:20px;">

      <div style="display: flex;align-items: center;">
        <div style="width:80px;">次数：</div>
        <el-input-number v-model="points" :step="1" :min="0" step-strictly style="width:400px;"
          size="small"></el-input-number>
      </div>
      <div style="display: flex;align-items: center;">
        <div style="width:80px;">有效期：</div>
        <el-date-picker v-model="dateRange" size="small" type="daterange" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          :clearable="false" style="width:400px;padding:3px 10px;">
        </el-date-picker>
      </div>

      <template v-if="mode == 'quotation'">
        <el-image style="width:50px; height:50px;margin-top:40px;" :src="GetResourceUrl('backend/SJT.svg')"></el-image>
        <div>商机通</div>
        <div>获取订单对应采购商企业信息及电话 <span style="color: #EE8159;">{{ points }}次</span></div>
      </template>

      <template v-else>
        <el-image style="width:50px; height:50px;margin-top:40px;" :src="GetResourceUrl('backend/SCT.svg')"></el-image>
        <div>速采通</div>
        <div>获取订单对应供应商企业信息及电话 <span style="color: #EE8159;">{{ points }}次</span></div>
      </template>


      <div>有效期 <span style="color: #EE8159;margin-left: 20px;">{{ dateRange[0] }} ~ {{ dateRange[1] }}</span></div>

      <div style="margin:40px;">
        <el-button size="small" style="width:80px" @click="Hide">取 消</el-button>
        <el-button size="small" type="primary" style="width:80px;margin-left:20px" @click="submitForm">确 定</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "JoinMember",
  mixins: [dialogMixin],
  props: ["roleList"],
  data() {
    return {
      id: null,
      mode: "", //quotation purchase
      dateRange: [
        this.$utils.formatDate(new Date()),
        this.$utils.formatDate(new Date().getTime() + 3600 * 1000 * 24 * 365),
      ],
      points: 365,
    };
  },
  methods: {
    submitForm() {
      this.axios.put(`/api/admin_user/${this.id}/join_member/`, {
        id: this.id,
        mode: this.mode,
        points: this.points,
        start_time: this.dateRange[0],
        end_time: this.dateRange[1],
      }).then(() => {
        this.$emit("submitDialog");
        this.Hide();
      });

    },
  },
};
</script>


<style scoped lang="scss"></style>
